'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routes from './pages.routes.js';

export default angular.module('georgeApp.pages',
  [uiRouter])
  .config(routes)
  .name;
